import { RSAA } from 'redux-api-middleware';
import { cached_fetch } from '../../../utils/cached';

export const FETCH_COUNTRY_CKU_MAP_BY_ID_REQUEST =
  '@@map/FETCH_COUNTRY_CKU_MAP_BY_ID_REQUEST';
export const FETCH_COUNTRY_CKU_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_COUNTRY_CKU_MAP_BY_ID_SUCCESS';
export const FETCH_COUNTRY_CKU_MAP_BY_ID_FAILURE =
  '@@map/FETCH_COUNTRY_CKU_MAP_BY_ID_FAILURE';

export const FETCH_CB_CLUSTER_MAP_BY_ID_REQUEST =
  '@@map/FETCH_CB_CLUSTER_MAP_BY_ID_REQUEST';
export const FETCH_CB_CLUSTER_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_CB_CLUSTER_MAP_BY_ID_SUCCESS';
export const FETCH_CB_CLUSTER_MAP_BY_ID_FAILURE =
  '@@map/FETCH_CB_CLUSTER_MAP_BY_ID_FAILURE';

export const FETCH_CB_AREA_MAP_BY_ID_REQUEST =
  '@@map/FETCH_CB_AREA_MAP_BY_ID_REQUEST';
export const FETCH_CB_AREA_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_CB_AREA_MAP_BY_ID_SUCCESS';
export const FETCH_CB_AREA_MAP_BY_ID_FAILURE =
  '@@map/FETCH_CB_AREA_MAP_BY_ID_FAILURE';

export const FETCH_CB_THANA_MAP_BY_ID_REQUEST =
  '@@map/FETCH_CB_THANA_MAP_BY_ID_REQUEST';
export const FETCH_CB_THANA_MAP_BY_ID_SUCCESS =
  '@@map/FETCH_CB_THANA_MAP_BY_ID_SUCCESS';
export const FETCH_CB_THANA_MAP_BY_ID_FAILURE =
  '@@map/FETCH_CB_THANA_MAP_BY_ID_FAILURE';

export const FETCH_PARTNER_UPDATE_DATA_REQUEST =
  '@@map/FETCH_PARTNER_UPDATE_DATA_REQUEST';
export const FETCH_PARTNER_UPDATE_DATA_SUCCESS =
  '@@map/FETCH_PARTNER_UPDATE_DATA_SUCCESS';
export const FETCH_PARTNER_UPDATE_DATA_FAILURE =
  '@@map/FETCH_PARTNER_UPDATE_DATA_FAILURE';

export const FETCH_PARTNER_TRANSACTION_SUMMARY_REQUEST =
  'FETCH_PARTNER_TRANSACTION_SUMMARY_REQUEST';
export const FETCH_PARTNER_TRANSACTION_SUMMARY_SUCCESS =
  'FETCH_PARTNER_TRANSACTION_SUMMARY_SUCCESS';
export const FETCH_PARTNER_TRANSACTION_SUMMARY_FAILURE =
  'FETCH_PARTNER_TRANSACTION_SUMMARY_FAILURE';

export const FETCH_PARTNERS_REQUEST = '@@map/FETCH_PARTNERS_REQUEST';
export const FETCH_PARTNERS_SUCCESS = '@@map/FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILURE = '@@map/FETCH_PARTNERS_FAILURE';

export const FETCH_PARTNERS_WITH_TRANSACTION_REQUEST =
  '@@map/FETCH_PARTNERS_WITH_TRANSACTION_REQUEST';
export const FETCH_PARTNERS_WITH_TRANSACTION_SUCCESS =
  '@@map/FETCH_PARTNERS_WITH_TRANSACTION_SUCCESS';
export const FETCH_PARTNERS_WITH_TRANSACTION_FAILURE =
  '@@map/FETCH_PARTNERS_WITH_TRANSACTION_FAILURE';

export const fetch_cb_country_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/countries/${id}/?expand&cat`,
    method: 'GET',
    types: [
      FETCH_COUNTRY_CKU_MAP_BY_ID_REQUEST,
      FETCH_COUNTRY_CKU_MAP_BY_ID_SUCCESS,
      FETCH_COUNTRY_CKU_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_cb_cluster_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/cb_clusters/${id}/?expand`,
    method: 'GET',
    types: [
      FETCH_CB_CLUSTER_MAP_BY_ID_REQUEST,
      FETCH_CB_CLUSTER_MAP_BY_ID_SUCCESS,
      FETCH_CB_CLUSTER_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_cb_area_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/cb_areas/${id}/?expand`,
    method: 'GET',
    types: [
      FETCH_CB_AREA_MAP_BY_ID_REQUEST,
      FETCH_CB_AREA_MAP_BY_ID_SUCCESS,
      FETCH_CB_AREA_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_cb_thana_map_by_id = id => ({
  [RSAA]: {
    endpoint: `/api/world/cb_thanas/${id}/?expand`,
    method: 'GET',
    types: [
      FETCH_CB_THANA_MAP_BY_ID_REQUEST,
      FETCH_CB_THANA_MAP_BY_ID_SUCCESS,
      FETCH_CB_THANA_MAP_BY_ID_FAILURE
    ],
    fetch: cached_fetch
  }
});

export const fetch_partner_update_data = (
  selectedState,
  id,
  filterType,
  filteringDateRange
) => ({
  [RSAA]: {
    endpoint: `/api/gis/partners/partner_update/?${selectedState}&id=${id}&type=${filterType}&date=${filteringDateRange}`,
    method: 'GET',
    types: [
      FETCH_PARTNER_UPDATE_DATA_REQUEST,
      FETCH_PARTNER_UPDATE_DATA_SUCCESS,
      FETCH_PARTNER_UPDATE_DATA_FAILURE
    ]
  }
});

export const fetch_partner_transaction_summary_data = (
  selectedState,
  id,
  filterType,
  filteringDateRange
) => ({
  [RSAA]: {
    endpoint: `/api/gis/partner_transactions/summary/?${selectedState}&id=${id}&type=${filterType}&date=${filteringDateRange}`,
    method: 'GET',
    types: [
      FETCH_PARTNER_TRANSACTION_SUMMARY_REQUEST,
      FETCH_PARTNER_TRANSACTION_SUMMARY_SUCCESS,
      FETCH_PARTNER_TRANSACTION_SUMMARY_FAILURE
    ]
  }
});

export const fetch_partners = (selectedState, id) => {
  return {
    [RSAA]: {
      endpoint: `api/gis/partners/all/?${selectedState.toLowerCase()}=${id}`,
      method: 'GET',
      types: [
        FETCH_PARTNERS_REQUEST,
        FETCH_PARTNERS_SUCCESS,
        FETCH_PARTNERS_FAILURE
      ]
    }
  };
};

export const fetch_partners_with_transaction = (
  selectedState,
  id,
  filterType,
  filteringDateRange
) => ({
  [RSAA]: {
    endpoint: `/api/gis/partners/transaction_summary/?${selectedState.toLowerCase()}=${id}&type=${filterType}&date=${filteringDateRange}`,
    method: 'GET',
    types: [
      FETCH_PARTNERS_WITH_TRANSACTION_REQUEST,
      FETCH_PARTNERS_WITH_TRANSACTION_SUCCESS,
      FETCH_PARTNERS_WITH_TRANSACTION_FAILURE
    ]
  }
});
